'use client';

// ─────────────────────────────────────────────────────────────
// 根層路由段錯誤邊界 (error)
//
// 兜底掛在根佈局下的「非業務頁」渲染錯誤：首頁、登入 / 註冊 /
// 忘記密碼等（業務頁另由 app/(main)/error.tsx 兜底）。根佈局仍在，
// 故可使用 globals.css 與共用元件。
// ─────────────────────────────────────────────────────────────

import { useEffect } from 'react';
import { reportError } from '@/lib/reportError';
import { ErrorFallback } from '@/components/common/ErrorFallback';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, 'app/error');
  }, [error]);

  return <ErrorFallback fullHeight onReset={reset} />;
}
